export default __webpack_public_path__ + "static/media/sweaterneck1.d22ef573.png";